import React, { useState, useEffect } from 'react';
import './TableList.css';
import EventFormModal from './EventFormModal';

export default function EventsList() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name-az');
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);

  const fetchEvents = () => {
    setLoading(true);
    const token = localStorage.getItem('jwtToken');

    if (!token) {
      setError('Token JWT lipsă. Reautentifică-te.');
      setLoading(false);
      return;
    }

    fetch('https://www.fro.ro/api/events/index.php', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      cache: 'no-store',
    })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Eroare ${res.status}: ${text}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data.success) {
          setEvents(data.data || []);
          setError(null);
        } else {
          setError(data.message || 'Eroare la încărcarea evenimentelor');
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Eroare fetch evenimente:', err);
        setError(err.message || 'Eroare de conexiune');
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleDelete = (eventId) => {
    if (!window.confirm('Sigur dorești să ștergi acest eveniment?')) return;

    const token = localStorage.getItem('jwtToken');
    const backendUrl = 'https://www.fro.ro/api/events/delete.php';

    fetch(`${backendUrl}?id=${eventId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': 'Bearer ' + token,
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        if (data.success) {
          setEvents(prev => prev.filter(e => e.id !== eventId));
        } else {
          alert('Eroare la ștergere: ' + data.message);
        }
      })
      .catch(error => {
        alert('Eroare la conexiune: ' + error.message);
      });
  };

  const handleEdit = (event) => {
    setEditingEvent(event);
    setShowAddModal(true);
  };

  const filteredEvents = events.filter(ev =>
    ((ev.name || '') + ' ' + (ev.location || '')).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedEvents = [...filteredEvents].sort((a, b) => {
    if (sortBy === 'name-az') {
      return (a.name || '').localeCompare(b.name || '');
    } else if (sortBy === 'location-az') {
      return (a.location || '').localeCompare(b.location || '');
    } else if (sortBy === 'date') {
      return new Date(a.start_date) - new Date(b.start_date);
    }
    return 0;
  });

  if (loading) return <p>Se încarcă evenimentele...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div className="table-list-container">
      <div className="table-list-header">
        <div className="sort-bar">
          <label htmlFor="sort-select" className="sort-label">Sort by:</label>
          <select
            id="sort-select"
            className="sort-select"
            value={sortBy}
            onChange={e => setSortBy(e.target.value)}
          >
            <option value="name-az">A-Z by name</option>
            <option value="location-az">A-Z by location</option>
            <option value="date">Dată</option>
          </select>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
          <input
            type="text"
            className="search-bar"
            placeholder="Search"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
          <button
            className="add-circle-btn"
            onClick={() => {
              setEditingEvent(null);
              setShowAddModal(true);
            }}
            aria-label="Adaugă eveniment"
          >
            <span className="plus-icon">+</span>
          </button>
        </div>
      </div>
      <table className="table-list">
        <thead>
          <tr>
            <th>Nume</th>
            <th>Perioadă</th>
            <th>Locație</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {sortedEvents.length === 0 ? (
            <tr>
              <td colSpan={6}>Nu există evenimente.</td>
            </tr>
          ) : (
            sortedEvents.map(event => (
              <tr key={event.id}>
              
                <td>{event.name}</td>
                <td>{event.start_date} - {event.end_date}</td>
                <td>{event.location}</td>
                <td className="table-list-actions">
                  <button onClick={e => {
                    e.stopPropagation();
                    handleEdit(event);
                  }}>Edit</button>
                  <button onClick={e => {
                    e.stopPropagation();
                    handleDelete(event.id);
                  }}>Delete</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {showAddModal && (
        <EventFormModal
          onClose={() => {
            setShowAddModal(false);
            setEditingEvent(null);
            fetchEvents();
          }}
          onEventAdded={fetchEvents}
          editData={editingEvent}
        />
      )}
    </div>
  );
}
